export enum FeatureFlagEnum {
  Auth0 = 'auth0',
  Auth0V4 = 'auth0v4',
  /**
   * ERP-15430 — gates ONLY the cross-app (V2↔V4) session-logout sync:
   * the heartbeat bootstrap/poll and the logout `endSession` cookie clear.
   * Deliberately separate from `Auth0V4`, which still gates the rest of
   * V2's Auth0 functionality (JWT scheme, auto-login, error handling).
   * V4 reads the SAME key (`inactivity.service.ts`) so both apps engage
   * the session machinery together or not at all.
   */
  V2V4SessionLogout = 'v2-v4-session-logout',
  DD_SessionReplayRecording = 'DD_SessionReplayRecording',
}
